import { AST } from '@handlebars/parser';
import { NodeType } from '../../../node/types';

export const isBooleanLiteral = (expression: AST.Node): expression is AST.BooleanLiteral =>
  expression.type === NodeType.BooleanLiteral;
